namespace app.model.tagging {
  export class TagForm implements Form {
    public id: string;
    public projectId: string;
    public roleId: string;
    public elements: TagFormElement[];

    constructor(projectId: string, roleId: string, id?: string, elements?: TagFormElement[]) {
      this.projectId = projectId;
      this.roleId = roleId;
      this.id = id;
      this.elements = elements ? elements : [];
    }
  }
}
